import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { Discrete, ServiceType } from "@framework/shared";

export const discreteRoutes: Array<RouteObject> = [
  {
    path: "/discrete",
    element: <Protected />,
    children: [
      { index: true, element: <Discrete service={ServiceType.ADMIN} /> },
      { path: "/discrete/:id/:action", element: <Discrete service={ServiceType.ADMIN} /> },
    ],
  },
];
